import { Menu, MenuItem, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;

  handleOpenEditLinkedinAccountGeneralSettingsDialog(): void;

  handleOpenEditLinkedinAccountLoginInformationDialog(): void;

  handleOpenEditEmailCredentialsDialog(): void;

  handleOpenManageEmailSendersDialog?: (() => void);

  generateShareableEditPath?(): void;

  handleOpenRemoveLinkedinAccountDialog?(): void;

  handleOpenEditLinkedinAccountNameDialog?(): void;

  handleOpenEditSignatureDialog?(): void;

  handleLogin?(): void;

  handleLogout?(): void;

  // NEW: open limits & schedule dialog
  handleOpenEditLimitsDialog?: () => void;
  // Assign SAIA license dialog
  handleOpenAssignLicenseDialog?: () => void;
  // NEW: reset local storage dialog
  handleOpenResetLocalStorageDialog?: () => void;
  handleOpenAccountConnectionsDialog?: () => void;
  handleCloseMenu(): void;
}

const AccountItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  handleOpenEditLinkedinAccountGeneralSettingsDialog,
  handleOpenEditLinkedinAccountLoginInformationDialog,
  handleOpenEditEmailCredentialsDialog,
  handleOpenManageEmailSendersDialog,
  generateShareableEditPath,
  handleOpenRemoveLinkedinAccountDialog,
  handleOpenEditLinkedinAccountNameDialog,
  handleOpenEditSignatureDialog,
  handleLogin,
  handleLogout,
  handleOpenEditLimitsDialog,
  handleCloseMenu,
  handleOpenAssignLicenseDialog,
  handleOpenResetLocalStorageDialog,
  handleOpenAccountConnectionsDialog,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenEditLinkedinAccountGeneralSettingsDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('editGeneralSettings')}</Typography>
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenEditLinkedinAccountLoginInformationDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('editLoginInformation')}</Typography>
      </MenuItem>
      {!_.isNil(handleOpenEditLinkedinAccountNameDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenEditLinkedinAccountNameDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editUsername')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenEditSignatureDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenEditSignatureDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editLinkedinSignature')}</Typography>
        </MenuItem>
      ) : null}
      {/* Manage e-mail senders (new multi-sender feature) */}
      {!_.isNil(handleOpenManageEmailSendersDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenManageEmailSendersDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('manageEmailSenders')}</Typography>
        </MenuItem>
      ) : (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenEditEmailCredentialsDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editEmailCredentials')}</Typography>
        </MenuItem>
      )}
      {!_.isNil(generateShareableEditPath) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            generateShareableEditPath();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editExternally')}</Typography>
        </MenuItem>
      ) : null}
      {/* NEW: Edit Limits & Schedule */}
      {!_.isNil(handleOpenEditLimitsDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenEditLimitsDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('editLimitsAndSchedule')}</Typography>
        </MenuItem>
      ) : null}
      {/* Assign SAIA license */}
      {!_.isNil(handleOpenAssignLicenseDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenAssignLicenseDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('assignLicense')}</Typography>
        </MenuItem>
      ) : null}

      {!_.isNil(handleOpenAccountConnectionsDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenAccountConnectionsDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('accountConnections')}</Typography>
        </MenuItem>
      ) : null}

      {/* NEW: Reset LinkedIn local storage */}
      {!_.isNil(handleOpenResetLocalStorageDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenResetLocalStorageDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('resetLocalStorage')}</Typography>
        </MenuItem>
      ) : null}

      {!_.isNil(handleLogin) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleLogin();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('login')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleLogout) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleLogout();
            handleCloseMenu();
          }}
        >
          <Typography className={classes.menuItemText}>{t('logout')}</Typography>
        </MenuItem>
      ) : null}
      {!_.isNil(handleOpenRemoveLinkedinAccountDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenRemoveLinkedinAccountDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={cx(classes.menuItemText, 'delete')}>{t('remove')}</Typography>
        </MenuItem>
      ) : null}
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '8px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.action.hover,
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default AccountItemMenu;
